<template>
  <div class="flex flex-column gap-2">
    <label>Schedule CPM change (Rest Of The World)</label>
    <div class="flex gap-1">
      <InputNumber
        v-model="newValue"
        :min="0"
        :minFractionDigits="0"
        :maxFractionDigits="4"
        placeholder="New CPM"
        class="w-full"
        :inputStyle="{ width: '100%' }"
      />
      <Calendar
        v-model="date"
        dateFormat="M d, yy"
        placeholder="Date"
        class="w-full"
      />
      <Dropdown
        v-model="hour"
        :options="hourOptions"
        optionLabel="label"
        optionValue="value"
        class="w-full"
      />
    </div>
    <Button
      label="Schedule"
      icon="pi pi-clock"
      :loading="rateChanges.saving"
      :disabled="!canSchedule"
      @click="scheduleChange"
    />
    <small v-if="nextChange" class="text-color-secondary">
      Next: → ${{ Number(nextChange.new_value) }} at
      {{ formatUtc(nextChange.effective_at) }}
      <template v-if="rateChanges.openChanges.length > 1">
        (+{{ rateChanges.openChanges.length - 1 }} more)
      </template>
      — see the Rate changes tab
    </small>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import moment from "moment";
import Button from "primevue/button";
import InputNumber from "primevue/inputnumber";
import Calendar from "primevue/calendar";
import Dropdown from "primevue/dropdown";

// eslint-disable-next-line no-undef
const props = defineProps({
  // useSellerRateChanges() of this seller
  rateChanges: { type: Object, required: true },
});

const hourOptions = Array.from({ length: 24 }, (_, h) => ({
  label: `${String(h).padStart(2, "0")}:00 UTC`,
  value: h,
}));

// The usual case: the start of next month
const nextMonthStart = () => {
  const start = moment.utc().add(1, "month").startOf("month");
  return new Date(start.year(), start.month(), start.date());
};

const newValue = ref(null);
const date = ref(nextMonthStart());
const hour = ref(0);

// Calendar returns the picked day as a local date: rebuild it as UTC
const effectiveAt = computed(() =>
  date.value
    ? new Date(
        Date.UTC(
          date.value.getFullYear(),
          date.value.getMonth(),
          date.value.getDate(),
          hour.value
        )
      )
    : null
);

const canSchedule = computed(
  () => newValue.value != null && effectiveAt.value > new Date()
);

const nextChange = computed(() => props.rateChanges.openChanges[0]);

const formatUtc = (iso) => `${moment.utc(iso).format("MMM D, YYYY HH:mm")} UTC`;

const scheduleChange = async () => {
  if (await props.rateChanges.schedule(newValue.value, effectiveAt.value)) {
    newValue.value = null;
  }
};
</script>
